import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const PessoaJuridicaList = props => <DefaultDataTable data={props} />;
